<template>
  <div style="max-height: 350px;overflow-y: auto">
    <el-button v-if="voiceObj.push_type !== 2" type="primary" plain @click="addVoice()">新增</el-button>&nbsp;
    <el-table
      v-loading="loading"
      element-loading-text="加载中，请耐心等待。"
      :data="showTable"
      border
      style="width: 100%;"
      highlight-current-row
    size="mini">
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center">
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        min-width="70"
        align="center">
      </el-table-column>
      <el-table-column
        prop="text"
        label="通知内容"
        min-width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="username"
        label="发送人"
        min-width="65"
        align="center">
      </el-table-column>
      <el-table-column
        label="推送状态"
        min-width="70"
        align="center">
        <template slot-scope="scope">
          <strong style="color: red" v-if="scope.row.tag === 1">已推送</strong>
          <strong style="color: green" v-else-if="scope.row.tag === 2">已阅读</strong>
          <span v-else>{{scope.row.tag}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="push_tm"
        label="推送时间"
        min-width="135"
        align="center">
      </el-table-column>
      <el-table-column
        label="阅读时间"
        min-width="135"
        align="center">
        <template slot-scope="scope">
          <span>{{showReadTm(scope.row)}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCells">
      </el-pagination>
    </div>
    <el-dialog
      :visible.sync="voiceShow"
      v-if="voiceShow"
      width="650px"
      :show-close="true"
      :close-on-click-modal="false"
      append-to-body
      class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>语音通知</span>
        </div>
        <div class="line-title"></div>
      </div>
        <voice-open-show :device="voiceObj" v-model="voiceShow" @getFatherVoice="getFatherVoice"></voice-open-show>
    </el-dialog>
  </div>
</template>

<script>
import {queryvoicemessagestatusbydid} from '../../../api/voice'
import voiceOpenShow from './voiceOpenShow'
export default {
  name: 'didVoiceDetails',
  components: {voiceOpenShow},
  model: {
    prop: 'openDetails',
    event: 'change'
  },
  props: {
    voiceObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      row: '',
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      showTable: [],
      tableData: [],
      loading: false,
      voiceShow: false
    }
  },
  created () {
    this.row = this.voiceObj.device
    this.getVoiceByDid()
  },
  mounted () {
  },
  methods: {
    getFatherVoice () {
      this.getVoiceByDid()
    },
    getVoiceByDid () {
      this.loading = true
      let data = {
        did: this.row.id
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      queryvoicemessagestatusbydid(data, params).then(res => {
        this.totalCells = res.data.cnt
        this.showTable = res.data.voicemessagestatus
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getVoiceByDid()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getVoiceByDid()
    },
    addVoice () {
      this.voiceShow = true
    },
    showReadTm (row) {
      const stime = Date.parse(new Date(row.push_tm))
      const etime = Date.parse(new Date(row.read_tm))
      const usedTime = etime - stime
      if (usedTime > 0) {
        return row.read_tm
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/didVoiceDetails.vue